<template>
	<!--部署类型-->
	<section class="deploy-index publish-main">
		<el-radio-group v-model="deployType" :disabled="hid">
			<v-radio :label="109002" :src="require('../img/7.png')">容器化应用</v-radio>
			<v-radio :label="109003" :src="require('../img/8.png')">SAAS应用</v-radio>
			<v-radio :label="3" disabled :src="require('../img/9.png')">独立应用</v-radio>
		</el-radio-group>
	</section>
</template>

<script>
	import vRadio from './radio'
	import titleArea from './title_area'
	export default {
		name: 'vDeploy',

		data() {
			return {
				deployType: 109002,
				hid: false,
				hidsub: false,
				hidsubv: false,
      }
		},

		components: {
			vRadio,
			titleArea
		},
		
		watch: {
			'$parent.tCloudApp': {
				handler(val) {
					this.deployType =  parseInt(val.deployType);
				},
				deep: true
			},
			'$parent.hid': {
				handler(val) {
					this.hid = val;
				},
				deep: true
			},
		},
		
		props: {
			data: {}
		},

		mounted: function() {
			this.$nextTick(function() {
			})
		},

		methods: {
			verify() {//form表单的校验结果
				var temp =this;
				return {
					flag:true,
					status: 1,
					form: {deployType:temp.deployType}
				};
			},
		}
	}
</script>

<style scoped>
.deploy-index {
	margin-left: 80px;
	padding-top: 50px;
}
</style>


// WEBPACK FOOTER //
// deploy.vue?459ac82a